/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import sessionStatus from 'state/reducers/session_status';
import appStatus from 'state/reducers/app_status';
import modalStatus from 'state/reducers/modal_status';
import messageStatus from 'state/reducers/message_status';
// import accountData from 'state/reducers/account_data';
import authStatus from 'state/reducers/auth_status';
import accountData from 'state/reducers/accountState/account_data';
// import contentAnalyticsData from 'state/reducers/content_analytics_data';
// import contentAnalyticsStatus from 'state/reducers/content_analytics_status';
// import embedAnalyticsData from 'state/reducers/embed_analytics_data';
// import embedAnalyticsStatus from 'state/reducers/embed_analytics_status';
// import embedManagementData from 'state/reducers/embed_management_data';
// import embedManagementStatus from 'state/reducers/embed_management_status';
import homeRootReducer from 'state/reducers/homeState/root';
// import insightsStatus from 'state/reducers/insights_status';
import overlayStatus from 'state/reducers/overlay_status';
import userStatus from 'state/reducers/user_status'
import embedsStateRootReducer from 'state/reducers/embedsState/root';
import reportsStateRootReducer from 'state/reducers/reportsState/root';
import profileStatus from 'state/reducers/profile_status';
import detailViewStatus from 'state/reducers/detailViewState/detailView_status';




/* ========== ~~~~~~~~~~ ROOT REDUCER ~~~~~~~~~~ ========== */
// COMBINE REDUCERS
// used to comhine all various reducers together into an easily accesible object
// utilized in store.js

const rootReducer = combineReducers({
	router: routerReducer,
    embedsState: embedsStateRootReducer,
    reportsState: reportsStateRootReducer,
    sessionStatus,
    appStatus,
    modalStatus,
    messageStatus,
    profileStatus,
    accountData,
    authStatus,
    detailViewStatus,
    // contentAnalyticsData,
    // contentAnalyticsStatus,
    // embedAnalyticsData,
    // embedAnalyticsStatus,
    // embedManagementData,
    // embedManagementStatus,
    homeState: homeRootReducer,
    // insightsStatus,
    overlayStatus,
    userStatus
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default rootReducer;
